import {
    UNDELETE_USER_ERROR,
    UNDELETE_USER_START,
    UNDELETE_USER_SUCCESS,
} from '../../actions/actionTypes';
import initialState from '../initialState';

export default (state = initialState.user.undelete, action = {type: ''}) => {
    switch (action.type) {
        case UNDELETE_USER_START:
            return {
                ...state,
                error: false,
                loading: true,
                success: false,
            };
        case UNDELETE_USER_SUCCESS:
            return {
                ...state,
                error: false,
                loading: false,
                success: true,
            };
        case UNDELETE_USER_ERROR:
            return {
                ...state,
                error: true,
                loading: false,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/userReducer/undeleteUserReducer.js